var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.value
    ? _c(
        "w-card",
        {
          staticClass: "drop-shadow afterSave root",
          attrs: { "max-width": "500" },
        },
        [
          _c(
            "w-card-title",
            [
              _vm._v(" " + _vm._s(_vm.$ct("report-status-title")) + " "),
              _c("w-spacer"),
              _c(
                "w-link",
                {
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-content",
            { staticClass: "hide-overflow" },
            [
              _c("w-row", { attrs: { "no-margin": "" } }, [
                _vm.job
                  ? _c("div", { staticClass: "w100" }, [
                      _vm.running
                        ? _c(
                            "div",
                            { key: "1", staticClass: "running" },
                            [
                              _c("div", {
                                directives: [
                                  {
                                    name: "safe-html",
                                    rawName: "v-safe-html",
                                    value: _vm.$ct("report-queued"),
                                    expression: "$ct('report-queued')",
                                  },
                                ],
                              }),
                              _c("w-spacer"),
                              _c("w-progress-circular", { staticClass: "mt" }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm.value
    ? _c("app-download-report-modal", {
        attrs: { value: _vm.value },
        on: { close: _vm.close },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }